import { Category } from "../types/event-response.type";

export function getParentCategoriesUtil(array: Category[], targetId: number): Category[] {
  const foundItem = array.find(item => item.category_id === targetId);

  if (foundItem) {
    return [foundItem];
  }

  let foundSubItem: Category[] = [];

  array.forEach((item) => {
    if (!foundSubItem.length) {
      foundSubItem = getParentCategoriesUtil(item.subcategories ?? [], targetId);

      if (foundSubItem.length) {
        foundSubItem = [item, ...foundSubItem];
      }
    }
  })

  return foundSubItem;
}
